import { Navigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from './pages/Home';
import Region from './pages/Region';
import Album from './pages/Album';
import Help from './pages/Help';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import AlbumEditor from './pages/AlbumEditor';
import Blogie from './pages/Blogie';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import NewPost from './pages/NewPost';
import Posts from './pages/Posts';
import EditPost from './pages/EditPost';
import Terms from './pages/Terms';
import Agreement from './pages/Agreement';
import SurveyResults from './pages/SurveyResults';
import SurveyList from './pages/SurveyList';
import SurveyNew from './pages/SurveyNew';
import SurveyDetail from './pages/SurveyDetail';
import SurveyPublic from './pages/SurveyPublic';
import SurveyEdit from './pages/SurveyEdit';
import NotFound from './pages/NotFound';
import Settings from './pages/Settings';
import Messages from './pages/Messages';
import CreatorProfile from './pages/CreatorProfile';
import Chroniques from './pages/Chroniques';
import Campaign from './pages/Campaign';
import AdminManage from './pages/AdminManage';
import Banner from './components/Banner';
import SiteSeal from './components/SiteSeal';
import NewsletterSignup from './pages/NewsletterSignup';
import Privacy from './pages/Privacy';
import ConfirmNewsletter from './pages/ConfirmNewsletter';
import { LangProvider } from './siteLang';
import CampaignArchive from './pages/CampaignArchives';
import Contact from './pages/Contact';
import Login from './pages/Login';
import ChooseSpace from './pages/ChooseSpace';
import Unsubscribe from './pages/Unsubscribe';
import { LoginModalProvider } from './LoginModalContext';
import LoginModal from './components/LoginModal';
import VideoTeaser from './components/VideoTeaser';
import Postcard from './pages/Postcard'
import AdminSessionGuard from "./components/AdminSessionGuard";
import Communiques from './pages/Communiques'; // adjust the path to match your other page imports

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <LangProvider>
      <LoginModalProvider>
        <Banner />
        <AnimatePresence mode='wait'>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/region/:regionName" element={<Region />} />
            <Route path="/region/:regionName/:albumName" element={<Album />} />
            <Route path="/help" element={<Help />} />
            <Route path="/admin" element={<Navigate to="/login" replace />} />
            <Route path="/admin/login" element={<Navigate to="/login" replace />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/upload" element={<Upload />} />
            <Route path="/admin/album/:albumName" element={<AlbumEditor />} />
            <Route path="/blogie" element={<Blogie />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/new-post" element={<NewPost />} />
            <Route path="/admin/posts" element={<Posts />} />
            <Route path="/admin/edit-post/:slug" element={<EditPost />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/agreement" element={<Agreement />} />
            <Route path="/survey" element={<Navigate to="/s/student-dashboard-2026" replace />} />
            <Route path="/admin/survey" element={<SurveyResults />} />
            <Route path="/admin/surveys" element={<SurveyList />} />
            <Route path="/admin/surveys/new" element={<SurveyNew />} />
            <Route path="/admin/surveys/:id" element={<SurveyDetail />} />
            <Route path="/s/:slug" element={<SurveyPublic />} />
            <Route path="/admin/surveys/:id/edit" element={<SurveyEdit />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/creator/:username" element={<CreatorProfile />} />
            <Route path="/admin/messages" element={<Messages />} />
            <Route path="/chroniques" element={<Chroniques />} />
            <Route path="/campaign/:year" element={<Campaign />} />
            <Route path="/admin/manage" element={<AdminManage />} />
            <Route path="/newsletter" element={<NewsletterSignup />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/confirm-newsletter" element={<ConfirmNewsletter />} />
            <Route path="/campaigns" element={<CampaignArchive />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/choose-space" element={<ChooseSpace />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/postcard" element={<Postcard />} />
            <Route path="/communiques" element={<Communiques />} />
          </Routes>
        </AnimatePresence>
        <SiteSeal />
        <VideoTeaser />
        <LoginModal />
      </LoginModalProvider>
    </LangProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AdminSessionGuard />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;